import axios from 'axios'
import qs from 'qs'
import config from '@/config'

import router from '../router'
import store from '@/store'

const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro
axios.defaults.baseURL = baseUrl

export const postRequest = (url, params) => {
  return axios({
    method: 'post',
    url: `${url}`,
    data: params
  })
}

export const getRequest = (url, params) => {
  return axios.get(url, {
    params: params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

axios.interceptors.request.use(config => {
  return config
})

axios.interceptors.response.use(response => {
  // 兼容 code: 0 和 code: 200
  if (response.data && (response.data.code === 0 || response.data.code === 200)) {
    return response
  }
  return response
}, error => {
  console.error('请求错误:', error)
  return Promise.reject(error)
})

export const openUrl = (url, params) => {
  let param = ''
  for (let field in params) {
    if (params[field]) {
      param += field + '=' + params[field] + '&'
    }
  }
  param = param.substring(0, param.length - 1)
  let URL = url + '?' + param
  window.open(URL)
}

export const downloadExcel = (url, param) => {
  var x = new XMLHttpRequest()
  x.open('POST', url, true)
  x.setRequestHeader('Content-type', 'application/json')
  x.setRequestHeader('Token', getToken())
  x.responseType = 'arraybuffer'
  x.onload = function (e) {
    if (x.status === 200) {
      var blob = x.response
      var a = document.createElement('a')
      var binaryData = []
      binaryData.push(blob)
      var url = window.URL.createObjectURL(new Blob(binaryData, {type: 'application/zip'}))
      a.href = url
      let filedesc = decodeURI(x.getResponseHeader('Content-Disposition'))
      let filename = filedesc.substring(filedesc.indexOf('=') + 1)
      a.download = filename
      a.click()
    }
  }
  x.send(JSON.stringify(param))
}



// WEBPACK FOOTER //
// ./src/api/request.js